import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { errorMessages } from '../../../../utils/errors/constants';
import useErrorState from '../../../../utils/errors/useErrorState';
import { resolve } from '../../../../utils/object/pathResolver';

const CheckboxQuestion = ({ rendering, fields, displayErrors, state, onError, id }) => {
  const [error, setError] = useErrorState(rendering.uid, fields.name?.value, fields, onError);
  const [checkedChildren, setCheckedChildren] = useState([]);
  const [initialRender, setInitialRender] = useState(true);
  const errorClass = error && displayErrors ? 'vds-checkbox--invalid' : '';
  const className = 'vds-checkbox vds-checkbox--contained ' + errorClass;

  const validate = children => {
    if (!fields.minSelection?.value && !fields.maxSelection?.value) {
      return true;
    }

    if (fields.minSelection?.value) {
      if (children.length < fields.minSelection?.value) {
        setError(errorMessages.TOO_FEW);
        return false;
      }
    }

    if (fields.maxSelection?.value) {
      if (children.length > fields.maxSelection?.value) {
        setError(errorMessages.TOO_MANY);
        return false;
      }
    }

    setError(null);
    return true;
  };

  const trackChildFromRender = components => {
    if (!initialRender) {
      return;
    }
    if (components && components.length > 0) {
      let newCheckedChildren = [...checkedChildren];
      let updateState = false;
      components.forEach(component => {
        const uid = component.key;
        if (component.props?.fields?.reduxValuePath?.value) {
          const value = resolve(component.props.fields.reduxValuePath.value, state);
          if (value && !newCheckedChildren.includes(uid)) {
            newCheckedChildren.push(uid);
            updateState = true;
          }
        }
      });
      if (updateState) {
        setCheckedChildren(newCheckedChildren);
      }
    }
  };

  const trackChild = (uid, value) => {
    if (value && checkedChildren.includes(uid)) {
      return;
    }
    let newCheckedChildren = [];
    if (value) {
      newCheckedChildren = [...checkedChildren, uid];
    } else {
      newCheckedChildren = checkedChildren.filter(c => c !== uid);
    }
    validate(newCheckedChildren);
    setCheckedChildren(newCheckedChildren);
  };

  useEffect(() => {
    validate(checkedChildren);
    return () => {
      setError(null);
    };
  }, [checkedChildren]);

  useEffect(() => {
    setInitialRender(false);
  }, []);

  const getCheckbox = () => {
    return (
      <div className={className}>
        <div className="vds-checkbox__items">
          <Placeholder
            name="checkbox-items"
            rendering={rendering}
            id={id || rendering.uid}
            error={error && displayErrors}
            onError={onError}
            setError={setError}
            trackChild={trackChild}
            render={components => {
              trackChildFromRender(components);
              return <>{components}</>;
            }}
          />
        </div>
      </div>
    );
  };

  const getContainedCheckbox = () => {
    return (
      <div className="vds-d2c-form-page__section">
        <div className="vds-d2c-form-page__inner">
          <div className="vds-form__group">{getCheckbox()}</div>
        </div>
      </div>
    );
  };

  return (
    <>
      {fields.isContained?.value ? getContainedCheckbox() : getCheckbox()}
      {displayErrors && fields.inlineError?.value && error && (
        <div className="vds-form__group">
          <div className="vds-form__validation-message vds-form__validation-message--invalid">
            <span
              className="vds-form__validation-text"
              data-errormessageorigin={error.name}
              data-errormessagetype={error.type}
              data-testid="error-message"
            >
              {error.message}
            </span>
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state, props) => {
  const reduxValuePath = props.fields.reduxValuePath?.value;
  let defaultValue;
  if (reduxValuePath) {
    defaultValue = reduxValuePath.split('.').reduce((o, i) => o[i], state);
  }
  return {
    ...props,
    defaultValue,
    displayErrors: state.appState?.displayErrors,
    state,
  };
};
export default connect(mapStateToProps)(CheckboxQuestion);
